module.exports = __webpack_public_path__ + "static/media/new-new-theano.fc37270e.svg";